import { useEffect, useState } from 'react';

const Preview = ({ build }) => {
  const pages = build.selectedPages;
  const [active, setActive] = useState(0);

  useEffect(() => {
    setActive((a) => (pages.length ? a % pages.length : 0));
    const t = setInterval(() => {
      if (pages.length) setActive((a) => (a + 1) % pages.length);
    }, 2200);
    return () => clearInterval(t);
  }, [pages.length]);

  const isWp = build.platform === 'wp';
  const has = (id) => build.addons.includes(id);

  return (
    <div className="overflow-hidden rounded-2xl border border-[#E2E8F0] bg-white text-[#1d1d1f] shadow-[0_30px_80px_-30px_rgba(0,0,0,0.3)]">
      <div className="flex items-center gap-1.5 bg-[#F1F5FB] px-3 py-2">
        <span className="h-2 w-2 rounded-full bg-[#ff5f57]" />
        <span className="h-2 w-2 rounded-full bg-[#febc2e]" />
        <span className="h-2 w-2 rounded-full bg-[#28c840]" />
        <span className="ml-2 rounded bg-white px-2 py-0.5 text-[10px] text-[#64748B]">
          yourbusiness.com{isWp ? '/wp-admin' : ''}
        </span>
      </div>
      <div className="flex flex-wrap gap-1 px-3 pt-3">
        {pages.map((p, i) => (
          <button
            key={i}
            onClick={() => setActive(i)}
            className={`rounded-full px-2 py-0.5 text-[10px] font-semibold transition-all ${
              i === active ? 'bg-[#1d1d1f] text-white' : 'text-[#64748B]'
            }`}
          >
            {p}
          </button>
        ))}
        {(has('blog') || isWp) && <span className="popin rounded-full px-2 py-0.5 text-[10px] font-semibold text-[#0F5EFF]">Blog</span>}
      </div>
      <div className="flex h-44 flex-col items-center justify-center gap-2 px-6">
        <div className="h-2 w-32 rounded-full bg-[#1d1d1f]" />
        <div className="h-2 w-20 rounded-full bg-[#E2E8F0]" />
        <p className="mt-2 text-base font-semibold">{pages[active]}</p>
        <div className="mt-2 flex gap-2">
          <span className="rounded-full bg-[#25D366] px-3 py-1 text-[10px] font-semibold text-white">WhatsApp</span>
          {has('booking') && (
            <span className="popin rounded-full border border-[#1d1d1f] px-3 py-1 text-[10px] font-semibold">Book now</span>
          )}
        </div>
      </div>
    </div>
  );
};

export default Preview;
